import React from 'react';

const Contact = () => {
    return (
        <div>
            <h1>Contact</h1>
            <p>Lorem Ipsum...</p>
        </div>
    );
}
export default Contact;